import { Component, OnInit ,ViewChild, ElementRef} from '@angular/core';
import { GlobalDataService } from '../../_shared';
import { ReportService } from '../../_services';
import {  Supplier, Report, DropAmtComnt, LoginUser} from '../../_models';
import * as XLSX from 'xlsx'; 
import { VarianceComnt } from '../../_models/variance-comment';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
@Component({
  standalone: false,
  selector: 'app-drop-comment-report',
  templateUrl: './drop-comment-report.component.html',
  styleUrls: ['./drop-comment-report.component.css']
})
export class DropCommentReportComponent implements OnInit {
  suppliersResult: Supplier[] = [];
  objectAccountsResult: string[] = [];
  getMonths: string[] = [];
  getYrs : string[]=[];
  user: LoginUser = new LoginUser;
   SupplierAB!: string | null;
   ObjectAccount = '';  
   Year = '';  
   Month='';
   UpdatedMonth='';
   MonthRb: boolean = false;
   UpdatedMonthRb: boolean = true;
  rptData = new Report();
  dropAmtComnt: DropAmtComnt[]  = [];
  varianceComnt: VarianceComnt[]  = [];
  Rpt:string='0';
  arrayList: Array<string> = [];
  @ViewChild('TABLE', { static: false })
  TABLE!: ElementRef;  
  p: any;

  constructor(private gd : GlobalDataService,
  private reportService  : ReportService,) { }

  ngOnInit() {
    this.user = this.gd.getUserData();
    this.getSuppliers();
    this.getObjectAccount();
    this.getAcurlYr();
    this.getMonths = this.gd.monthNames;
  }
  
  getSuppliers()
  {
    this.suppliersResult= this.gd.getSupplierData();
    this.arrayList = this.suppliersResult.map(sup => sup.SupplierAB.toString().trim() +"-" +sup.SupplierName.toString().trim()); 
  }

  searchSupplier = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchObjectAcnt = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.objectAccountsResult.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )


  getAcurlYr()
  {
    for (var i = 0; i <= 20; i++) {
      this.getYrs.push(((new Date().getFullYear()) - i).toString());
    }
  }

  getObjectAccount()
  {
    
    this.objectAccountsResult=this.gd.getAccountData();
  }

  getDropAmtComnt()
  {
    this.rptData.supplierAB=(this.SupplierAB==null || this.SupplierAB.trim()=='')?0: parseInt(this.SupplierAB.split('-')[0]);
    this.rptData.objectAccount=this.ObjectAccount;
    this.rptData.year=this.Year;
    if(!this.MonthRb)
    {
      this.rptData.Month = this.Month;
    }else{
      this.rptData.Month = this.UpdatedMonth;
    }
    
   if(this.Rpt=="0")
   {
    this.reportService.varianceCommentReport(this.rptData).subscribe(data=>{
      if(data !=null)
      {
      this.varianceComnt = data;
      for (let i=0;i<this.varianceComnt.length;i++)
      {
        this.varianceComnt[i].ObjectAccount = this.objectAccountsResult.filter(t=>t.split('-')[0].trim()== this.varianceComnt[i].ObjectAccount.trim())[0];
        this.varianceComnt[i].SupName =this.varianceComnt[i].SupplierAB+"-"+ this.suppliersResult.filter(t=>t.SupplierAB== this.varianceComnt[i].SupplierAB)[0].SupplierName;
      } 
      this.dropAmtComnt = [];
      }
    });
   }
   else
   {
     if(!this.MonthRb)
     {
      this.reportService.dropCommentReport(this.rptData).subscribe(data=>{
        if(data !=null)
        {
        var temp: any = data;
        for (let i=0;i<temp.length;i++)
        {
         temp[i].SupName =temp[i].SupplierAB+"-"+ this.suppliersResult.filter(t=>t.SupplierAB== temp[i].SupplierAB)[0].SupplierName;
         temp[i].Period = this.getMonths[new Date(temp[i].FromDate).getMonth()] +"-"+new Date(temp[i].FromDate).getFullYear();
         temp[i].CreatedDate = new Date(temp[i].CreatedDate).getDate() +"-"+this.getMonths[new Date(temp[i].CreatedDate).getMonth()] +"-"+new Date(temp[i].CreatedDate).getFullYear();
        } 
        this.dropAmtComnt = temp;
        this.varianceComnt = [];
        }
      });
     }
     else
     {
      this.reportService.dropCommentUpdatedReport(this.rptData).subscribe(data=>{
        if(data !=null)
        {
        var temp: any = data;
        for (let i=0;i<temp.length;i++)
        {
          temp[i].SupName =temp[i].SupplierAB+"-"+ this.suppliersResult.filter(t=>t.SupplierAB== temp[i].SupplierAB)[0].SupplierName;
          temp[i].Period = this.getMonths[new Date(temp[i].FromDate).getMonth()] +"-"+new Date(temp[i].FromDate).getFullYear();
          temp[i].CreatedDate = new Date(temp[i].CreatedDate).getDate() +"-"+this.getMonths[new Date(temp[i].CreatedDate).getMonth()] +"-"+new Date(temp[i].CreatedDate).getFullYear();
        } 
        this.dropAmtComnt = temp;
        this.varianceComnt = [];
        }
      });
     }
     }
     }
    
  
  ExportTOExcel() {  
      var reportGrid = (this.dropAmtComnt!=null) ?document.getElementById("reportGrid_all"):document.getElementById("reportGrid_all_var")
      var wb: XLSX.WorkBook = XLSX.utils.book_new();
      let ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(reportGrid);
      wb.SheetNames.push("Sheet1");
      wb.Sheets["Sheet1"] = ws;
  
      /* save to file */
      XLSX.writeFile(wb, 'VarianceReport' + new Date().toDateString() + '_' + new Date().getTime().toString() + '.xlsx');
  }

  EnableDropDown(){
    this.MonthRb  = !this.MonthRb;
    this.UpdatedMonthRb = !this.UpdatedMonthRb;    
    if(this.MonthRb)
    {
      this.Month = "";
      
    }
    if(this.UpdatedMonthRb)
    {
      this.UpdatedMonth = "";
    }
  }
}
